// extracted by mini-css-extract-plugin
module.exports = {"img":"component-module--img--3W3Yp","border":"component-module--border--27xLA","container":"component-module--container--3KX6t","caption":"component-module--caption--3or_i"};